import { h } from "preact";

import {

    Typography,

} from "@mui/material";

import { useContext, } from "preact/hooks";

import { AppContext } from "../../AppContext";
import LoadingButtonWithTooltip from "../Common/LoadingButtonWithTooltip";
import DownloadIcon from '@mui/icons-material/Download';

export default function DownloadFile({ f, mode, tooltip }) {
    console.log("DownloadFile", f, mode);
    const app = useContext(AppContext);
    function zsx(u, f) {

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ doc_uid: u })
        };
        fetch("/api/" + (mode === "iddoc" ? "cbd0322b259b4105abc6c398292e5c76" : mode === "docs" ? "a12ed705756f48f1b9d23371a5f61f5a" : mode === "arch" ? "2164bfe54de44697b1a636ba9fa4a9dd" : ""), requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        console.log("session download", res.pld)

                        const myRequest = new Request('/upload/dl/' + res.pld);

                        fetch(myRequest)
                            .then((response) => response.blob())
                            .then((myBlob) => {
                                const objectURL = URL.createObjectURL(myBlob);
                                var tempLink = document.createElement('a');
                                tempLink.style.display = 'none';
                                tempLink.href = objectURL;
                                tempLink.setAttribute('download', f);
                                if (typeof tempLink.download === 'undefined') {
                                    tempLink.setAttribute('target', '_blank');
                                }
                                document.body.appendChild(tempLink);
                                tempLink.click();
                                setTimeout(function () {
                                    document.body.removeChild(tempLink);
                                    window.URL.revokeObjectURL(objectURL);
                                    var btn = document.getElementById(u);
                                    console.log(btn);
                                    btn.remove();
                                    var lbl = document.getElementById('lbl-' + u);
                                    lbl.innerText = "En cours de téléchargement...";

                                }, 200)
                                var timerId = setInterval(() => {
                                    const myRequest = new Request('/upload/d893812e8c084e2e8efd6868685933b1/' + res.pld);
                                    fetch(myRequest)
                                        .then((response) => {
                                            return response.json();
                                        })
                                        .then((res) => {
                                            // console.log(res)

                                            if (res.res == "ok" && res.pld.s) {
                                                clearInterval(timerId);
                                                var lbl = document.getElementById('lbl-' + u);
                                                lbl.innerText = "Téléchargement terminé";
                                                lbl.style = "color: green; font-weight: bold;"
                                            }
                                        })
                                }, 1000);
                            });
                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });


    }
    return (
        <div>
            <Typography display={"inline"} variant="body1" id={`lbl-` + f.u}></Typography>
            <LoadingButtonWithTooltip
                icon={<DownloadIcon />}
                id={f.u}
                nolabel={mode !== "arch"}
                label={"télécharger"}
                click={() => zsx(f.u, f.name)}
                tooltip={tooltip ? tooltip : "Télécharger"}

            />

        </div>

    );
}
